import { Router, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { LanguageQuery } from './../queries/language-query';
import { Language } from './../data/language';

@Injectable()
export class LanguageService {
  private mFind: Observable<Language[]>;

  constructor(private router: Router, private route: ActivatedRoute) {

  }

  public find() {
    if (!this.mFind) {
      this.mFind = new LanguageQuery().include(Language.FLAG_KEY).rx().find();
    }
    return this.mFind;
  }

  public getCurrentLang(): Observable<string> {
    return this.route.queryParams.map(o => {
      return o['lang'] || this.defaultLang;
    });
  }

  public get defaultLang() {
    return Language.DEFAULT_LANG;
  }
  
  public rendered() {
    return this.getCurrentLang().map(() => false).merge(this.getCurrentLang().debounceTime(100).map(() => true));
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/services/language-service.ts